import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  border: 1px solid var(--vo-cloud);
  border-radius: 10px;
  overflow: hidden;
`;

const LabelCell = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: var(--vo-ink-2);
  padding: 11px 16px;
  background: var(--vo-mist);
  border-bottom: 1px solid var(--vo-mist);
  &:nth-last-child(2) { border-bottom: none; }
`;

const ValueCell = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: var(--vo-celeste);
  padding: 11px 20px;
  text-align: right;
  background: var(--vo-mist);
  border-bottom: 1px solid var(--vo-mist);
  &:last-child { border-bottom: none; }
`;

export const IndicatorResume = ({ indicatorResume }) => {
  const { t } = useTranslation('mapping');
  const rows = [
    { label: t('ropa.executiveSummary.businessAreas'), value: indicatorResume?.areaQuantity },
    { label: t('ropa.executiveSummary.areasWithPersonalData'), value: indicatorResume?.areaPersonalDataQuantity },
    { label: t('ropa.executiveSummary.areasWithSensitiveData'), value: indicatorResume?.areaSensitivePersonalDataQuantity },
    { label: t('ropa.executiveSummary.processesLabel'), value: indicatorResume?.processQuantity },
    { label: t('ropa.executiveSummary.processesNeedDPIA'), value: indicatorResume?.processDPIAQuantity },
    { label: t('ropa.executiveSummary.processesNeedLIA'), value: indicatorResume?.processLIAQuantity },
    { label: t('ropa.executiveSummary.systemsAndAssets'), value: indicatorResume?.assetAndSystemQuantity },
    { label: t('ropa.executiveSummary.legalBasesUsed'), value: indicatorResume?.legalBaseQuantity },
  ];
  return (
    <Grid>
      {rows.map((row, i) => (
        <Fragment key={i}>
          <LabelCell>{row.label}</LabelCell>
          <ValueCell>{row.value ?? 0}</ValueCell>
        </Fragment>
      ))}
    </Grid>
  );
};
